/*same page scroll*/
document.addEventListener('DOMContentLoaded', function () {
  const smoothScrollLinks = document.querySelectorAll('a[href^="#"]');
  const headerHeight = document.querySelector('header').offsetHeight; // Adjust based on your header selector

  smoothScrollLinks.forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});
/*end Same page scroll*/



/*


  document.addEventListener("DOMContentLoaded", function () {
  function hideButtons() {
    var elements = document.querySelectorAll(".wk_extended_warranty_btn");
    elements.forEach(function (element) {
      element.style.display = "none";
    });
  }

  function showButtonsIfActiveBlockExists() {
    var activeBlocks = document.querySelectorAll(
      ".wk_extend_warr_div.wk_active_block"
    );
    if (activeBlocks.length > 0) {
      var buttons = document.querySelectorAll(".wk_extended_warranty_btn");
      buttons.forEach(function (button) {
        button.style.display = "block";
      });
    }
  }

  // Run the function immediately to hide the buttons
  hideButtons();

  // Check periodically
  setInterval(function () {
    hideButtons();
    showButtonsIfActiveBlockExists();
  }, 1000);
});

*/